import { VStack, Grid, Text } from '@chakra-ui/react'

import CourseListItem from '@/features/Courses/components/CourseListItem'

import { logEvent } from '@/lib/stats'

import { Course } from '@/features/Courses/types'

interface Props {
  courses: Course[]
}

function CourseList({ courses }: Props): React.ReactElement {
  return (
    <VStack
      spacing={{
        base: 8,
        md: 10,
      }}
      sx={{
        py: {
          base: '80px',
          md: '100px',
        },
      }}
    >
      <Text
        sx={{
          fontSize: {
            base: '2xl',
            md: '4xl',
          },
          fontWeight: 'bold',
          color: 'primary.800',
          textAlign: 'center',
        }}
      >
        คอร์สอื่น ๆ ที่คุณอาจสนใจ
      </Text>
      <Grid
        sx={{
          gridTemplateColumns: {
            base: '1fr',
            sm: `repeat(${Math.min(courses.length, 3)}, 1fr)`,
          },
          gridGap: 6,
        }}
      >
        {courses.map((course) => {
          return (
            <CourseListItem
              key={course.title}
              course={course}
              onClick={() => {
                logEvent({
                  ga: {
                    category: 'Course Detail-Course',
                    action: 'Click suggested course',
                    label: course.slug,
                  },
                })
              }}
            />
          )
        })}
      </Grid>
    </VStack>
  )
}

export default CourseList
